// подключаем главную функцию с которой начинается выполнение
import {main, mainDebug} from 'boot';

// конфигурационный файл, определяющий сетевой идентификатор игры
import gameConfig from 'cfg/game-config.js';

// сгенерированная информация о версии игры
import versionInfo from './version';

// функция построения компонентов игры
import construct from './construct';

// графическая метрика пользовательского интерфейса
import uiConfig from 'cfg/userinterface-config';

import screenConfig from 'cfg/screen-config';

import resources from 'res/resources';

import { TYPE } from 'network/network_api';
import SETTINGS from "settings"

console.log(versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate);

// политика совершения пользователем выбора в бонусах
/*
const bonusUserSelectionsPolicy = [{
    type : TYPE.BONUS_1,
    from : 0,
    to : 4,
    exclusive : true    // выбор пользователя уникален от шага к шагу бонуса
},
{
    type : TYPE.BONUS_2,
    from : 0,
    to : 4,
    exclusive : true    // выбор пользователя уникален от шага к шагу бонуса
}];
*/

// entry point
SETTINGS.user_interface = [ "res/user_interface.json", 'res/user_interface_font.xml' ];
SETTINGS.canvas = screenConfig.resolution;
main(
    resources,
    construct,
    {
        gameNetworkId:gameConfig.gameNetworkId,
        gameName:versionInfo.name,
        totalizator : true,
        /*bonusUserSelectionsPolicy*/
    },
    {},
    uiConfig,
    screenConfig,
    versionInfo
);

// тот вариант когда хочется подергать сцену самому тогда вызов предыдущей main нужно закоментировать
/*
import SlotScene from './slotscene';

mainDebug (screenConfig, resources, root => {
    const slot = new SlotScene();
    root.addChild(slot);
});
//*/



// WEBPACK FOOTER //
// ./src/main.es6